import React, {Fragment, Component} from 'react';
import * as PropTypes from 'prop-types';
import {formGroupStyles} from "../SecurityGroups/create/styles/CreateSecurityGroup.css";
import Field from "redux-form/es/Field";
import ValidationTextBox from "../common/ValidationTextBox";
import {maxLength, required} from "../../functions/validationRules";
import ValidationTextArea from "../common/ValidationTextArea";
import {reduxForm} from "redux-form";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {updateSecurityGroup} from "../../actions/SecurityGroupActions";

const maxLength100 = maxLength(100);
const maxLength500 = maxLength(500);

class SecurityGroupForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      description: '',
      securityGroup: {}
    };
  }

  getValuesFromForm = () => {
    if (!this.props.form || !this.props.form.values)
      return {name: "", description: ""};
    let name = this.props.form.name || "";
    let description = this.props.form.description || "";
    return {name, description};
  };

  componentWillMount() {
    let {name, description} = this.props.securityGroup;
    if (name || description)
      this.props.initialize({name: name || "", description: description || ""});
    else
      this.props.initialize({name: "", description: ""});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.securityGroup !== this.state.securityGroup) {
      this.setState({securityGroup: nextProps.securityGroup});
    }
    if (nextProps.securityGroup && nextProps.securityGroup.name !== "") {
      if (!nextProps.form || nextProps.form.name === "") {
        let {name, description} = nextProps.securityGroup;
        this.props.initialize({name, description});
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.securityGroup !== prevState.securityGroup) {
      if (!prevState.securityGroup.name && this.state.securityGroup.name !== prevState.securityGroup.name) {
        let {name, description} = this.state.securityGroup;
        this.props.initialize({name, description});
      }
    }
  }

  render() {
    return (
      <Fragment>
        <div className="form-group row" style={formGroupStyles}>
          <Field
            className="form-control input-lg"
            type="text"
            name="name"
            label="Security Group Name"
            component={ValidationTextBox}
            validate={[required, maxLength100]}
            disabled={this.props.disabled}
          />
        </div>
        <div className="form-group row" style={formGroupStyles}>
          <Field
            className="form-control input-lg"
            type="text"
            name="description"
            label="Security Group Description"
            component={ValidationTextArea}
            validate={[maxLength500]}
            disabled={this.props.disabled}
          />
        </div>
      </Fragment>
    );
  }
}

SecurityGroupForm.propTypes = {
  disabled: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    securityGroup: state.securityGroup.securityGroup,
    form: state.form.createSecurityGroup
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({updateSecurityGroup}, dispatch);
}

SecurityGroupForm = connect(mapStateToProps, mapDispatchToProps)(SecurityGroupForm);

export default reduxForm({
  form: "createSecurityGroup"
})(SecurityGroupForm);
